export function shouldShowProfilePage() {
  // The Profile menu always has at least the Change Password page to show,
  // regardless of which (if any) profile-relevant scopes the user has.
  return true;
}

export function getDefaultProfilePage({ permissions }) {
  if (permissions.ecommerce) return "/profile/basic-info";
  if (permissions.activemailer) return "/profile/mailer-integration";
  if (permissions.companyQuota || permissions.contactQuota)
    return "/profile/quotas";
  if (permissions.weeklyUpdateEmail) return "/profile/communications";
  return "/profile/security";
}
